import script from "./NewLead.vue?vue&type=script&setup=true&lang=js"
export * from "./NewLead.vue?vue&type=script&setup=true&lang=js"

import "./NewLead.vue?vue&type=style&index=0&id=4c43c072&lang=css"

const __exports__ = script;

export default __exports__